var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7778 5.64706C28.7778 4.14937 28.1281 2.71301 26.9716 1.65399C25.8151 0.594956 24.2466 0 22.6111 0H14.3889C12.7534 0 11.1849 0.594956 10.0284 1.65399C8.87192 2.71301 8.22222 4.14937 8.22222 5.64706H6.16667C4.53117 5.64706 2.96265 6.24202 1.80618 7.30104C0.649701 8.36007 0 9.79642 0 11.2941V26.3529C0 27.8506 0.649701 29.287 1.80618 30.346C2.96265 31.405 4.53117 32 6.16667 32H30.8333C32.4688 32 34.0374 31.405 35.1938 30.346C36.3503 29.287 37 27.8506 37 26.3529V11.2941C37 9.79642 36.3503 8.36007 35.1938 7.30104C34.0374 6.24202 32.4688 5.64706 30.8333 5.64706H28.7778ZM22.6111 3.76471H14.3889C13.8437 3.76471 13.3209 3.96303 12.9354 4.31603C12.5499 4.66904 12.3333 5.14783 12.3333 5.64706H24.6667C24.6667 5.14783 24.4501 4.66904 24.0646 4.31603C23.6791 3.96303 23.1563 3.76471 22.6111 3.76471ZM6.16667 9.41176H30.8333C31.3785 9.41176 31.9013 9.61008 32.2868 9.96309C32.6723 10.3161 32.8889 10.7949 32.8889 11.2941V26.3529C32.8889 26.8522 32.6723 27.331 32.2868 27.684C31.9013 28.037 31.3785 28.2353 30.8333 28.2353H6.16667C5.6215 28.2353 5.09866 28.037 4.71317 27.684C4.32768 27.331 4.11111 26.8522 4.11111 26.3529V11.2941C4.11111 10.7949 4.32768 10.3161 4.71317 9.96309C5.09866 9.61008 5.6215 9.41176 6.16667 9.41176Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.9feef6150d0e7f8d591e410de38367e0.svg";
export { ForwardRef as ReactComponent };